import { InfoText } from '@e3dc-react/shell/Elements/InfoText'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { format } from '@e3dc-react/shell/Libs/date'
import { Box, Tooltip, Typography } from '@mui/material'
import React from 'react'
import { Trans } from 'react-i18next'
import { Installation } from 'src/Libs/installations/models/installation.model'
import InstallationDeviceStatusRow from './InstallationDeviceStatusRow'

interface Props {
  installation: Installation
}
const PLACEHOLDER = 'installation-device-status.unknown'

const InstallationDeviceStateColumn: React.FC<Props> = ({ installation }) => {
  const { t } = useCustomTranslation()

  if (installation.decommissionedAt) {
    return (
      <DecommissionedContent
        decommissionedAt={installation.decommissionedAt}
        decommissionedByName={installation.decommissionedByName}
        decommissionedReason={installation.decommissionedReason}
      />
    )
  }

  if (installation.installationStatus === 'planned') return <StatusInfo installation={installation} text={t('installation.overview.planned')} />

  return <InstallationDeviceStatusRow installation={installation} placeHolderUi={PLACEHOLDER} />
}

export default InstallationDeviceStateColumn

interface DecommissionedContentProps {
  decommissionedAt: string
  decommissionedByName?: string
  decommissionedReason?: string
}

const DecommissionedContent: React.FC<DecommissionedContentProps> = ({ decommissionedAt, decommissionedByName, decommissionedReason }) => {
  const { t } = useCustomTranslation()
  const decommissionedBy = decommissionedByName ?? t('installation-details.deleted.unknown-user')
  const decommissionedReasonText = decommissionedReason ?? t('installation-details.deleted.unknown-reason')

  return (
    <Tooltip
      title={
        <Trans
          i18nKey={'installation.overview.deleted-tooltip'}
          values={{
            decommissionedAt: format(new Date(decommissionedAt), t('common.format.date-fns-date')),
            decommissionedBy,
            decommissionedReason: decommissionedReasonText,
          }}
          components={{ line: <Typography /> }}
        />
      }
    >
      <span>
        <InfoText value={t('common.deleted')} />
      </span>
    </Tooltip>
  )
}

// #region StatusInfo
interface StatusInfoProps {
  installation: Installation
  text: string
}

const StatusInfo: React.FC<StatusInfoProps> = ({ installation, text }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
      <InstallationDeviceStatusRow installation={installation} placeHolderUi={PLACEHOLDER} />
      <InfoText value={text} />
    </Box>
  )
}
// #endregion StatusInfo
